import type { TenantConfig } from "./tenants.config";

/**
 * Set document title, meta description, and favicon based on tenant config.
 *
 * Must be called **before** the first React render so the browser tab shows
 * the correct title and icon immediately.
 */
export function applyMeta(config: TenantConfig): void {
  // Document title
  document.title = config.meta.documentTitle;

  // Meta description
  if (config.meta.metaDescription) {
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", config.meta.metaDescription);
    }
  }

  // Favicon
  const faviconLink = document.querySelector(
    'link[rel="icon"]'
  ) as HTMLLinkElement | null;
  if (faviconLink) {
    faviconLink.href = config.assets.faviconUrl;
  }
}
